import axios, { AxiosInstance } from "axios";

export const request = (): AxiosInstance => {
  const authToken = localStorage.getItem("accessToken");
  return axios.create({
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
    },
    baseURL: process.env.REACT_APP_API_URL,
  });
};
